"use strict";

require("core-js/modules/es.reflect.construct.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.formatTime = exports.timeInterfaceName = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.function.name.js");

require("antd/lib/time-picker/style/index.css");

var _timePicker = _interopRequireDefault(require("antd/lib/time-picker"));

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _lodash = _interopRequireDefault(require("lodash"));

var _formElements = require("@evidation/form-elements");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var timeInterfaceName = "time (24-hour clock)";
exports.timeInterfaceName = timeInterfaceName;
var LittleButton = (0, _styledComponents["default"])(_formElements.Button).withConfig({
  displayName: "time__LittleButton"
})(["padding:0 7px;font-size:", "rem;border-radius:4px;height:24px;width:34px;"], 14 / 16);

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "time__Wrapper"
})([":first-child,.ant-time-picker{width:135px;input.ant-time-picker-input{:disabled{cursor:default;color:inherit;opacity:0.5;}}}"]);

var asterisk = (0, _styledComponents.css)(["content:'* ';"]);

var Label = _styledComponents["default"].label.withConfig({
  displayName: "time__Label"
})(["p:first-child:before{", "}"], function (p) {
  return p.required && asterisk;
});

var formatTime = function formatTime(inputVal, format) {
  if (inputVal) {
    //Test to see if the input string is valid datetime then parse to 24 hour time if it is
    var time = !_lodash["default"].isNaN(Date.parse(inputVal)) ? (0, _moment["default"])(inputVal).format(format) : inputVal;
    return (0, _moment["default"])(time, format);
  }

  return null;
};

exports.formatTime = formatTime;

var Time = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Time, _React$Component);

  var _super = _createSuper(Time);

  function Time() {
    var _this;

    (0, _classCallCheck2["default"])(this, Time);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      open: false,
      value: null
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleOpenChange", function (open) {
      if (open) _this.props.input.onFocus();else _this.props.input.onBlur();

      _this.setState({
        open: open
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClose", function () {
      _this.props.input.onBlur();

      _this.setState({
        open: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (value) {
      _this.props.input.onFocus();

      _this.setState({
        value: value
      });

      var change = value !== null ? value.format(_this.props.format) : value;

      _this.props.input.onChange(change);
    });
    return _this;
  }

  (0, _createClass2["default"])(Time, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.input.value) this.setState({
        value: formatTime(this.props.input.value, this.props.format)
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var inputVal = this.props.input.value;

      if (prevProps.input.value !== inputVal && (!this.state.value || inputVal !== this.state.value.format(this.props.format))) {
        this.setState({
          value: formatTime(inputVal, this.props.format)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$meta = _this$props.meta,
          error = _this$props$meta.error,
          touched = _this$props$meta.touched,
          use12Hours = _this$props.use12Hours,
          format = _this$props.format,
          defaultValue = _this$props.defaultValue,
          disabledHours = _this$props.disabledHours,
          disabled = _this$props.disabled,
          placeholder = _this$props.placeholder,
          id = _this$props.id,
          required = _this$props.required,
          description = _this$props.description,
          labelStyle = _this$props.labelStyle;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(Label, {
        required: required
      }, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, this.props.label || this.props.smallLabel)), /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_timePicker["default"], (0, _extends2["default"])({
        defaultOpenValue: (0, _moment["default"])(defaultValue, format),
        use12Hours: use12Hours,
        format: format,
        open: this.state.open,
        onOpenChange: this.handleOpenChange,
        onChange: this.onChange,
        disabledHours: disabledHours,
        disabled: disabled,
        placeholder: placeholder,
        id: id || "".concat(this.props.input.name, "_timepicker"),
        value: this.state.value,
        size: "large",
        addon: function addon() {
          return /*#__PURE__*/_react["default"].createElement(LittleButton, {
            type: "button",
            onClick: _this2.handleClose
          }, "Ok");
        }
      }, _lodash["default"].pick(this.props, timepicker_props)))), touched && error && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, error), description && /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
        labelStyle: labelStyle,
        label: "".concat(description),
        style: {
          fontSize: "80%"
        }
      }));
    }
  }]);
  return Time;
}(_react["default"].Component);

Time.handlesErrorDisplay = true;
var timepicker_props = ['addon', 'allowClear', 'autoFocus', 'className', 'clearText', 'defaultOpenValue', 'disabled', 'disabledHours', 'disabledMinutes', 'disabledSeconds', 'format', 'getPopupContainer', 'hideDisabledOptions', 'hourStep', 'inputReadOnly', 'minuteStep', 'open', 'placeholder', 'popupClassName', 'popupStyle', 'secondStep', 'suffixIcon', 'clearIcon', 'use12Hours', 'value', 'onChange', 'onOpenChange'];
Time.defaultProps = {
  label: "",
  format: 'HH:mm',
  defaultValue: '00:00',
  meta: {},
  input: {},
  disabled: false
};
var _default = Time;
exports["default"] = _default;